<template>
  <v-container fluid class="paystatement-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn v-if="!isPayroll" to="/paystatement/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn v-if="isPayroll" to="/payroll/list" color="primary" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end mt-3 mt-md-0">
                <div :style="$vuetify.breakpoint.smAndDown ? 'width: 100%' : 'width: 250px'">
                <v-text-field
                  dense
                  :full-width=$vuetify.breakpoint.smAndDown
                  outlined
                  hide-details
                  label="Search"
                  prepend-inner-icon="mdi-magnify"
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" class="d-flex justify-end mt-3">

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="paystatements-table"
              show-select
              single-select
              item-key="_id"
              sort-desc
              sort-by="paystatementnum"
              :footer-props="footer"
              :headers="headers"
              :items="paystatements"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Pay Statement?
                    </v-card-title>
                    <v-card-text>
                      {{ deletepaystatement.paystatementnum }} 
                      {{ deletepaystatement.paystatementname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deletepaystatement)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.employeeid="{ item }">
                <v-avatar v-if="employees.length>0" size="40">
                  <img v-bind:src="employees.find(employee=>employee._id == item.employeeid)['employeeimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <span class="white--text headline">{{ employees.find(employee=>employee._id == item.employeeid)['employeename'][0].toUpperCase() }}</span>
                </v-avatar>
                <span style="margin-left:15px">{{ item.paystatementname }} </span>
              </template>
              <template v-slot:item.paystatementnum="{ item }">
                <p class="two-line">{{ item.paystatementtype  }}</p>
                <p class="two-line">{{ item.paystatementnum  }}</p>
              </template>
              <template v-slot:item.paystatementaddress="{ item }">
                <p class="two-line">{{ item.paystatementaddress }}</p>
              </template>
              <template v-slot:item.paystatementstatus="{ item }">
                <v-chip
                  :color="item.paystatementstatus=='Complete' ? 'successConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.paystatementstatus }}
                </v-chip>
              </template>
              <template v-slot:item.paystatementdate="{ item }">
                {{ new Date(item.paystatementdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.paystatementnetpay="{ item }">
                {{ item.paystatementnetpay!=null ? item.paystatementnetpay.toLocaleString('en-SG') : '' }}
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn  v-if="item.paystatementstatus!=='Complete'" icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.paystatementstatus!=='Complete'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'PayStatementList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      deletepaystatement: {},
      headers: [
        { text: 'Num', value: 'paystatementnum' },
        { text: 'Date', value: 'paystatementdate' },
        { text: 'Employee', value: 'employeeid' },
        { text: 'Net Pay', value: 'paystatementnetpay' },
        { text: 'Status', value: 'paystatementstatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      isPayroll: false,
    }
  },
  computed: {
    ...mapState('PayStatement', ['paystatements', 'isReceiving', 'isDeleting', 'idToDelete', 'paystatementsMessage', 'isUpdating']),
    ...mapState('Employee', ['employees']),
  },
  created () {
    let payroll = this.$route.params;
    if(payroll==undefined || payroll._id ==undefined) this.getPayStatementsRequest(null);
    else {
      this.isPayroll = true;
      this.getPayStatementsRequest(payroll._id);
    }
    if(this.employees.length==0) {this.getEmployeesRequest()}
  },
  methods: {
    ...mapActions('PayStatement', ["getPayStatementsRequest","deletePayStatementRequest","updatePayStatementRequest","createPayStatementRequest"]),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    editItem(item) {
      this.$router.push({ name: 'PayStatementEdit', params: item })
    },
    printItem(item) {
      this.$router.push({ name: 'PayStatementPrint', params: item })
    },
    deleteItem(item) {
      this.deletePayStatementRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deletepaystatement = {
        _id: item._id,
        paystatementnum: item.paystatementnum,
        paystatementname: item.paystatementname,
      }
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
